// extracted by mini-css-extract-plugin
module.exports = {"input":"styles__input___3WWD4","textarea":"styles__textarea___29r-Q styles__input___3WWD4"};